import _ from 'lodash';

import {
  SSO_IDP_LOGIN_SSO_ONLY,
} from 'assets/js/api/environment';

export default {
  computed: {
    // entityIdForEmailDomain returns an entity id for an email domain if one
    // exists. These are supplied by the configuration level
    // SSO_IDP_LOGIN_SSO_ONLY.
    entityIdForEmailDomain() {
      if (!this.credentials.email) return null;
      if (this.credentials.email.split('@').length === 1) return null;
      if (process.env.NODE_ENV === 'development') return null;

      // Identify subdomains.
      if (_.some(
        _.keys(SSO_IDP_LOGIN_SSO_ONLY),
        (domain) =>
          _.includes(this.credentials.email.split('@').pop(), domain))) {
        return SSO_IDP_LOGIN_SSO_ONLY[_.find(_.keys(SSO_IDP_LOGIN_SSO_ONLY),
          (domain) =>
            _.includes(this.credentials.email.split('@').pop(), domain))];
      }

      // Not a subdomain (root level).
      return _.get(
        SSO_IDP_LOGIN_SSO_ONLY,
        this.credentials.email.split('@').pop(),
        null);
    },
  },
};
